import { render, staticRenderFns } from "./AccountManagementOwner.vue?vue&type=template&id=9b885a5c"
import script from "./AccountManagementOwner.vue?vue&type=script&lang=js"
export * from "./AccountManagementOwner.vue?vue&type=script&lang=js"
import style0 from "./AccountManagementOwner.vue?vue&type=style&index=0&id=9b885a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports